import { getTableColByKey } from "../../lib/utils/stats";
import React from "react";

export function TableHeader({ isWide, statCols }) {
  function getTitle(col) {
    const tableCol = getTableColByKey(col);
    return tableCol ? tableCol.field : col.toUpperCase();
  }

  function getDesc(col) {
    const tableCol = getTableColByKey(col);
    return tableCol ? tableCol.name : col;
  }

  return (
    <thead className="sticky -top-px z-10 bg-white dark:bg-gray-800 dark:text-gray-300">
      <tr>
        {/* Player1 headers */}
        <th className="border-b border-gray-200 py-1.5 pl-2 text-left align-bottom font-medium dark:border-gray-700">
          Player
        </th>

        {statCols.map((col, index) => (
          <th
            key={`left-${col}-${index}`}
            className="border-b border-gray-200 px-0.5 py-1.5 text-center font-medium dark:border-gray-700"
            title={getDesc(col)}
          >
            {getTitle(col)}
          </th>
        ))}

        {isWide && (
          <th className="border-b border-gray-200 dark:border-gray-700"></th>
        )}

        {isWide && (
          <th className="border-b border-gray-200 py-1.5 pl-2 text-left align-bottom font-medium dark:border-gray-700">
            Player
          </th>
        )}

        {isWide &&
          statCols.map((col, index) => (
            <th
              key={`right-${col}-${index}`}
              className="border-b border-gray-200 px-0.5 py-1.5 text-center font-medium dark:border-gray-700"
              title={getDesc(col)}
            >
              {getTitle(col)}
            </th>
          ))}
      </tr>
    </thead>
  );
}
